import { ReactNode } from 'react';
import styled from 'styled-components';

export type Variant = 'DEFAULT' | 'MEDIUM' | 'LARGE';
export interface InfoListItemProps {
  icon?: string | ReactNode;
  title?: string;
  body?: string;
  variant?: Variant;
  alignItems?: 'flex-start' | 'center';
  className?: string;
  trailingIcon?: ReactNode;
}

const Container = styled.div<{ alignItems: 'flex-start' | 'center' }>`
  display: flex;
  align-items: ${({ alignItems }) => alignItems};
`;

const Icon = styled.div<{ variant: Variant }>`
  margin-right: ${({ theme }) => theme.spacing.M16};
  ${({ variant }) => variant === 'LARGE' && 'width: 40px; height: 40px;'}
  display: flex;
  align-items: center;
`;

const Title = styled.div<{ variant: Variant }>`
  ${({ theme, variant }) =>
    variant === 'DEFAULT'
      ? theme.donedeal.fontSize.B14
      : theme.donedeal.fontSize.B16};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
  font-weight: ${({ theme, variant }) =>
    variant === 'LARGE'
      ? theme.donedeal.fontWeight.bold
      : theme.donedeal.fontWeight.regular};
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.S8};
`;

const Text = styled.p<{ variant: Variant }>`
  ${({ theme }) => theme.fontSize.B12};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  margin-top: ${({ theme }) => theme.spacing.S4};
`;

const TitleContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

function InfoListItem({
  icon,
  title,
  body,
  variant = 'DEFAULT',
  alignItems = 'flex-start',
  className,
  trailingIcon,
}: InfoListItemProps) {
  return (
    <Container alignItems={alignItems} className={className}>
      {icon && (
        <Icon variant={variant}>
          {typeof icon === 'string' ? <img src={icon} alt="" /> : icon}
        </Icon>
      )}
      <TitleContainer>
        <Title variant={variant}>
          {title}
          {trailingIcon}
        </Title>
        {body && <Text variant={variant}>{body}</Text>}
      </TitleContainer>
    </Container>
  );
}

export { InfoListItem };
